<template>
  <div>
      <div class="container-fluid footer-main">
        <div class="container" style="padding-bottom:2px;">
          <footer class="my-5 pt-1 text-center text-small" style="font-size:12px;">
            <h5 style="margin-top:20px;">İletişim Bilgilerimiz</h5>
            <p>
              {{ init.contact }}
              Tel: {{ init.phone }}
              Faks: {{ init.fax_number }}</p>
            <hr>
            <p class="mb-1">{{ init.footer_text }}</p>
            <hr style="margin-bottom:20px;">
            <router-link :to="{ name : 'Page', params : { slug: 'gizlilik-politikasi'}}" target="_blank"> <button type="button" class="btn btn-light btn-sm" style="margin:2px;">İptal, İade, Gizlilik ve Güvenlik Politikaları</button></router-link>
            <router-link :to="{ name : 'Page', params : { slug: 'kvkk-aydinlatma-metni'}}" target="_blank"> <button type="button" class="btn btn-light btn-sm" style="margin:2px;">KVKK Aydınlatma Metni</button></router-link>
          </footer>
        </div>
      </div>
      <div class="container-fluid bottom-text" style="min-height:40px; text-align:center; padding:10 10 10 10px;" >
        <div class="container">
          <p class="pb-3 pt-3"> 2021 © {{ init.client.title }}</p>
        </div>
      </div>
  </div>
</template>

<script>
  export default{
    name:'Footer',
    computed:{
      init(){
        return this.$store.getters['getInit'];
      },
    },
  }
</script>
